<template>





    <div class="game-board">
        <!-- 添加加载状态 -->
        <div v-if="!gameState" class="loading">
            Loading game data...
        </div>

        <!-- 添加游戏状态检查 -->
        <template v-else>
            <div v-if="gameOver" class="game-over">
                <h2>Game Over!</h2>
                <p>{{ winner }} wins!</p>
                <button @click="resetGame">Play Again</button>
            </div>

            <div v-else>
                <div class="game-info">
                    <p>Current Player: {{ currentPlayerName }}</p>
                    <p>Cards left in deck: {{ deckSize }}</p>
                </div>

                <!-- 对手区域 - 只显示牌背和位置 -->
                <div class="opponent-area">
                    <h3>{{ opponentName }}'s Cards</h3>
                    <div class="card-slots">
                        <div 
                            v-for="(_, index) in opponentCardCount" 
                            :key="index"
                            class="card-slot"
                            @click="selectOpponentPosition(index)"
                            :class="{ selected: selectedPosition === index }"
                        >
                            <div class="card-back">?</div>
                        </div>
                    </div>
                </div>

                <!-- 猜牌控制区 -->
                <div class="guess-controls" v-if="isCurrentPlayer">
                    <div v-if="selectedPosition !== null">
                        <div class="guess-inputs">
                            <select v-model="guessedNumber">
                                <option value="-1">- (万能牌)</option>
                                <option v-for="n in 12" :key="n" :value="n-1">{{ n-1 }}</option>
                            </select>
                            <select v-model="guessedColor">
                                <option value="BLACK">Black</option>
                                <option value="WHITE">White</option>
                            </select>
                        </div>
                        <button @click="makeGuess" :disabled="makingGuess">
                            Guess Position {{ selectedPosition + 1 }}
                        </button>
                    </div>
                    <div v-else>
                        <p>Select an opponent's card position to guess</p>
                    </div>
                </div>

                <!-- 玩家手牌区域 -->
                <PlayerHand 
                    :player-name="playerName"
                    :cards="playerHand"
                    :show-order="true"
                    @select-card="selectPlayerCard"
                />

                <!-- 抽牌和插入控制 -->
               <div v-if="drawnCard" class="drawn-card-area">
    <h3>You drew:</h3>
    <Card :number="drawnCard.number" :color="drawnCard.color" :is-wildcard="drawnCard.isWildcard" />
    
    <div class="insert-controls">
      <p>Insert at position:</p>
      <select v-model="insertPosition">
        <option v-for="(card, index) in playerHand" 
                :key="index" 
                :value="index">
          {{ index + 1 }}
        </option>
        <option :value="playerHand.length">End</option>
      </select>
      <button @click="confirmInsert">Confirm</button>
    </div>
  </div>

                <!-- 已展示的牌 -->
                <div class="table-cards" v-if="playerTable.length > 0">
                    <h3>Your Table:</h3>
                    <div class="cards-container">
                        <Card 
                            v-for="(card, index) in playerTable" 
                            :key="index" 
                            :number="card.number" 
                            :color="card.color"
                        />
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { computed, ref } from 'vue'
import PlayerHand from './PlayerHand.vue'
import Card from './CardVue.vue'
import { useGameStore } from '@/stores/game'
const insertPosition = ref(0);
export default {
    components: { PlayerHand, Card },
    props: {
        gameState: {
            type: Object,
            default: null
        },
        playerId: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const gameStore = useGameStore()
        const selectedPosition = ref(null)
        const guessedNumber = ref(0)
        const guessedColor = ref('BLACK')
        const makingGuess = ref(false)
        const drawnCard = ref(null)
        const insertPosition = ref(0)
        const revealedCard = ref(null)

        // 计算属性
        const playerName = computed(() => {
            if (!props.gameState) return ''
            return props.gameState.player1?.id === props.playerId 
                ? props.gameState.player1.name 
                : props.gameState.player2?.name || ''
        })

        const opponentName = computed(() => {
            if (!props.gameState) return 'Opponent'
            return props.gameState.player1?.id === props.playerId 
                ? props.gameState.player2?.name || 'Opponent'
                : props.gameState.player1?.name || 'Opponent'
        })

        const opponentCardCount = computed(() => {
            if (!props.gameState) return 0
            const opponent = props.gameState.player1?.id === props.playerId 
                ? props.gameState.player2 
                : props.gameState.player1
            return opponent?.hand?.length || 0
        })

        const isCurrentPlayer = computed(() => {
            return props.gameState?.currentPlayer?.id === props.playerId
        })

        const playerHand = computed(() => {
            if (!props.gameState) return []
            return props.gameState.player1?.id === props.playerId 
                ? props.gameState.player1?.hand || []
                : props.gameState.player2?.hand || []
        })

        const playerTable = computed(() => {
            if (!props.gameState) return []
            return props.gameState.player1?.id === props.playerId 
                ? props.gameState.player1?.table || []
                : props.gameState.player2?.table || []
        })

        const currentPlayerName = computed(() => {
            return props.gameState?.currentPlayer?.name || ''
        })

        const deckSize = computed(() => {
            return props.gameState?.deckSize || 0
        })

        const gameOver = computed(() => {
            return props.gameState?.gameOver || false
        })

        const winner = computed(() => {
            return props.gameState?.winner || ''
        })

        const fetchGameState = async () => {
      await gameStore.fetchGameState();
    };
    

    const opponentId = computed(() => {
      if (!props.gameState) return null;
      return props.gameState.player1?.id === props.playerId
        ? props.gameState.player2?.id
        : props.gameState.player1?.id;
    });
        // 方法
        const selectOpponentPosition = (position) => {
            if (isCurrentPlayer.value) {
                selectedPosition.value = position
            }
        }

        const selectPlayerCard = (card) => {
            // 可以选择自己的牌进行特殊操作（如果有）
        }
        const makeGuess = async () => {
      if (!opponentId.value || makingGuess.value) return;
      
      makingGuess.value = true;
      try {
        // 抽牌逻辑
        await gameStore.drawCard(props.gameState.gameId, props.playerId);
        
        // 猜牌逻辑
        const correct = await gameStore.makeGuess(
          props.playerId,
          opponentId.value,
          guessedNumber.value
        );
        
        if (correct) {
          await fetchGameState();
        }
      } finally {
        makingGuess.value = false;
      }
    };

        const confirmInsert = async () => {
            if (!drawnCard.value || !props.gameState) return
            
            try {
                await gameStore.insertCard(
                    props.gameState.gameId,
                    props.playerId,
                    drawnCard.value,
                    insertPosition.value
                )
                drawnCard.value = null
            } catch (error) {
                console.error("Insert failed:", error)
            }
        }

        const resetGame = () => {
            gameStore.resetGame()
        }


        return {
            playerName,
            opponentName,
            opponentCardCount,
            isCurrentPlayer,
            playerHand,
            playerTable,
            currentPlayerName,
            deckSize,
            gameOver,
            winner,
            selectedPosition,
            guessedNumber,
            guessedColor,
            makingGuess,
            drawnCard,
            insertPosition,
            revealedCard,
            selectOpponentPosition,
            selectPlayerCard,
            makeGuess,
            confirmInsert,
            resetGame,
      opponentId,
      fetchGameState
        }
    }
}
</script>

<style scoped>
.game-board {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
}

.loading {
    text-align: center;
    padding: 40px;
    font-size: 18px;
    color: #666;
}

.game-info {
    background-color: #e9ecef;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 20px;
    text-align: center;
}

.opponent-area {
    margin: 20px 0;
    text-align: center;
}

.card-slots {
    display: flex;
    justify-content: center;
    gap: 15px;
    margin: 15px 0;
}

.card-slot {
    width: 60px;
    height: 90px;
    border: 2px solid #ddd;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background-color: #f0f0f0;
}

.card-slot.selected {
    border-color: #007bff;
    background-color: #e6f0ff;
}

.card-back {
    font-size: 24px;
    color: #666;
}

.guess-controls {
    margin: 20px 0;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 8px;
    text-align: center;
}

.guess-inputs {
    display: flex;
    gap: 10px;
    justify-content: center;
    margin-bottom: 10px;
}

.guess-controls select {
    padding: 5px;
    border-radius: 4px;
    border: 1px solid #ced4da;
}

.guess-controls button {
    padding: 8px 20px;
    background-color: #28a745;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
}

.guess-controls button:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
}

.drawn-card-area {
    margin: 20px 0;
    padding: 15px;
    background-color: #e9ecef;
    border-radius: 8px;
    text-align: center;
}

.insert-controls {
    margin-top: 15px;
}

.insert-controls select {
    padding: 5px;
    margin: 0 10px;
    border-radius: 4px;
    border: 1px solid #ced4da;
}

.insert-controls button {
    padding: 5px 15px;
    background-color: #17a2b8;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.table-cards {
    margin-top: 30px;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 8px;
}

.game-over {
    text-align: center;
    padding: 30px;
    background-color: #f8d7da;
    border-radius: 8px;
    margin-bottom: 20px;
}

.game-over button {
    padding: 10px 20px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    margin-top: 15px;
}
</style>